var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DashboardLayout',[_c('PushNotificationBody',{attrs:{"notifications":_vm.notifications.pushnotifications,"loading":_vm.notifications.loading}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }